/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SampleRequestService = {

  async saveSampleRequest(payload) {
    const url = `api/CustomerSampleRequest`;
    return await ApiService.post(url, payload);
  },

  async getSampleRequestRecord(SampleCode) {
    const requestScreenData = {
      url: "api/CustomerSampleRequest",
      count: true,
      filter: `SampleCode eq ${SampleCode}`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getSampleRequestDetails(SampleCode) {
    const requestScreenData = {
      url: "api/CustomerSampleRequestDetail",
      count: true,
      filter: `SampleCode eq ${SampleCode}`,
    };
    return await ApiService.oDataGet(requestScreenData);
  }
};

export { SampleRequestService };
